// ConfirmationDialog.js
import React from 'react';

const ConfirmationAuth = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-box">
      <span class="icon21136242420013"><i class="fa fa-check"></i></span>

        <div className='tjeuthetet24355'>
        تبریک می‌گوییم!        </div>

        <div className='kdjhsdfgfg837263624'>

          
         شما موفق به احراز هویت سطح یک شده‌اید.

        </div>

        <div className='jjshjvgfs0082736232'>
 اکنون می‌توانید بدون هیچ محدودیتی از تمامی فرایندها به جز برداشت استفاده کنید.

برای فعال‌سازی امکان برداشت، لطفاً احراز هویت سطح دوم را انجام دهید.

        </div>
        <div className="dialog-actions">
          <button className="dialog-button panel" onClick={onClose}>پنل کاربری</button>
          <button className="dialog-button" onClick={onConfirm}>ارتقاء به سطح دو</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationAuth;
